import Login from './pages/Login';
import Register from './pages/Register';
import Notches from './pages/Notches';
import Collections from './pages/Collections';
import Settings from './pages/Settings';
import Statistics from './pages/Statistics';
import Sandbox from './pages/Sandbox';
import Notifications from './pages/Notifications';

import AuthRedirect from './hoc/AuthRedirect';
import PrivateRoute from './hoc/PrivateRoute';

const routes = [
  {
    path: '/login',
    element: <AuthRedirect><Login /></AuthRedirect>
  },
  {
    path: '/register',
    element: <AuthRedirect><Register /></AuthRedirect>
  },
  {
    path: '/notches',
    element: <PrivateRoute><Notches /></PrivateRoute>
  },
  {
    path: '/collections',
    element: <PrivateRoute><Collections /></PrivateRoute>
  },
  {
    path: '/settings',
    element: <PrivateRoute><Settings /></PrivateRoute>
  },
  {
    path: '/statistics',
    element: <PrivateRoute><Statistics /></PrivateRoute>
  },
  {
    path: '/notifications',
    element: <PrivateRoute><Notifications /></PrivateRoute>
  },
  {
    path: '/notifications/:id',
    element: <PrivateRoute><Notifications /></PrivateRoute>
  },
  {
    path: '/sandbox',
    element: <PrivateRoute><Sandbox /></PrivateRoute>
  },
  {
    path: '/',
    element: <AuthRedirect><Login /></AuthRedirect>
  }
];

export default routes;
